<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-12">
          <h1 class="mt-5">{{ subscriptionType }}</h1>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="!donePurchasing && !processingCreditCard">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Subscription Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <form class="standard-form">
            <ng-container *ngIf="purchaseType == 'I'">
              <mat-form-field>
                <mat-label>Subscription Plan</mat-label>
                <input matInput [value]="getSubscriptionPlanName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Level</mat-label>
                <input matInput [value]="getSubscriptionLevelName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Period</mat-label>
                <input matInput [value]="getSubscriptionPeriodName()" [readonly]="true" />
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="purchaseType == 'X'">
              <mat-form-field>
                <mat-label>Subscription Plan</mat-label>
                <mat-select (selectionChange)="updateSubscriptionLevels()"
                            name="subscriptionPlanId"
                            style="width: 100%"
                            [(ngModel)]="subscriptionPlanId">
                  <mat-option *ngFor="let sub of allXmlaSubTypes"
                              [value]="sub.xmlaSubscriptionTypeId">{{ sub.xmlaSubscriptionName }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Level</mat-label>
                <mat-select (selectionChange)="updateSubscriptionPeriods()"
                            name="subscriptionLevelId"
                            style="width: 100%"
                            [(ngModel)]="subscriptionLevelId">
                  <mat-option *ngFor="let lvl of selectedXmlaSubLevels"
                              [value]="lvl.xmlaSubscriptionLevelId">{{ lvl.description }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Period</mat-label>
                <mat-select (selectionChange)="updateSubscriptionPeriod()"
                            name="subscriptionPeriodId"
                            style="width: 100%"
                            [(ngModel)]="subscriptionPeriodId">
                  <mat-option *ngFor="let prc of selectedXmlaSubPrices"
                              [value]="prc.periodTypeId">
                    {{ prc.periodType.description }}
                    {{ prc.price | currency }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="purchaseType == 'A'">
              <mat-form-field>
                <mat-label>Subscription Plan</mat-label>
                <input matInput [value]="getSubscriptionPlanName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Level</mat-label>
                <input matInput [value]="getSubscriptionLevelName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Period</mat-label>
                <input matInput [value]="getSubscriptionPeriodName()" [readonly]="true" />
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="purchaseType == 'R'">
              <mat-form-field>
                <mat-label>Subscription Plan</mat-label>
                <input matInput [value]="getSubscriptionPlanName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Level</mat-label>
                <input matInput [value]="getSubscriptionLevelName()" [readonly]="true" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Subscription Period</mat-label>
                <input matInput [value]="getSubscriptionPeriodName()" [readonly]="true" />
              </mat-form-field>
            </ng-container>
          </form>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Purchasing Options</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <!-- <div class="row">
            <div class="col-md-8">
              <mat-checkbox
                name="userIsBuyer"
                [(ngModel)]="userIsBuyer"
              ></mat-checkbox>
              <ng-container *ngIf="!this.isProposal">
                &nbsp;&nbsp;&nbsp;&nbsp;<b>I am the Purchaser/Subscription Administrator for my Organization</b>
              </ng-container>
              <ng-container *ngIf="this.isProposal">
                &nbsp;&nbsp;&nbsp;&nbsp;<b>I am the Subscription Administrator for my Organization</b>
              </ng-container>
            </div>
            <div class="col-md-4"></div>
          </div> -->
          <div *ngIf="userIsBuyer" class="row">
            <div class="col-md-8">
              <mat-checkbox
                name="nonConsumer"
                [(ngModel)]="nonConsumer"
              ></mat-checkbox>
              &nbsp;&nbsp;&nbsp;&nbsp;<b
                >I will NOT be consuming a license seat</b
              >
            </div>
            <div class="col-md-4"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- <mat-card style="margin-top: 15px" *ngIf="!userIsBuyer">
      <mat-card-header>
        <mat-card-title>Purchaser Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <form class="standard-form">
            <mat-form-field>
              <mat-label>Purchaser Email</mat-label>
              <input
                matInput
                name="purchaserEmail"
                (keyup)="purchaserEmailChanged()"
                [(ngModel)]="purchaserEmail"
              />
            </mat-form-field>
            <ng-container *ngIf="!isExistingPurchaser">
              <mat-form-field>
                <mat-label>Re-Enter Purchaser Email</mat-label>
                <input
                  matInput
                  name="reEnterPurchaserEmail"
                  [(ngModel)]="reEnterPurchaserEmail"
                />
              </mat-form-field>
            </ng-container>
            <mat-form-field>
              <mat-label>Organization Name</mat-label>
              <input
                matInput
                name="purchaserOrganizationName"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserOrganizationName"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Title</mat-label>
              <input
                matInput
                name="purchaserTitle"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserTitle"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input
                matInput
                name="purchaserFirstName"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserFirstName"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input
                matInput
                name="purchaserLastName"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserLastName"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Address Line 1</mat-label>
              <input
                matInput
                name="purchaserAddress1"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserAddress1"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Address Line 2</mat-label>
              <input
                matInput
                name="purchaserAddress2"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserAddress2"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>City</mat-label>
              <input
                matInput
                name="purchaserCity"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserCity"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>State</mat-label>
              <input
                matInput
                name="purchaserState"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserState"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Zip</mat-label>
              <input
                matInput
                name="purchaserZip"
                [readonly]="isExistingPurchaser"
                [(ngModel)]="purchaserZip"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Purchaser Phone:</mat-label>
              <input
                matInput
                name="purchaserPhone"
                [(ngModel)]="purchaserPhone"
              />
            </mat-form-field>
          </form>
        </div>
      </mat-card-content>
    </mat-card> -->

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>License Agreement</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <mat-checkbox name="licenseAgree" [(ngModel)]="licenseAgree">
            I Agree to the
            <a [href]="tosUrl" target="_blank"
              >License Agreement Terms and Conditions</a
            ></mat-checkbox
          >
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Apply Coupon</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <form class="standard-form">
            <mat-form-field>
              <mat-label>Coupon or Trial Code</mat-label>
              <input matInput name="couponCode" [(ngModel)]="couponCode" />
            </mat-form-field>
            <button mat-raised-button class="piButton" (click)="getCouponOrPeriod()">
              Apply
            </button>
          </form>
          <span *ngIf="couponCodeError != ''" style="color: red">{{
            couponCodeError
          }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Order Details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Price</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderPrice | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Discount</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              <ng-container *ngIf="isFreeTrial">
                <b>FREE TRIAL</b>
              </ng-container>
              <ng-container *ngIf="!isFreeTrial">
                {{ orderDiscount | currency }}
              </ng-container>
            </div>
            <div class="col-md-1"></div>
          </div>
          <div *ngIf="isTaxable" class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Tax ({{this.taxRate | percent: '1.0-4'}})</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderSalesTax | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Total Due</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderTotalDue | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Payment Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row" *ngIf="allowInvoice && !isFreeTrial && orderTotalDue > 0">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <mat-radio-group
                name="orderPaymentMethod"
                [(ngModel)]="orderPaymentMethod"
              >
                <mat-radio-button value="CreditCard"
                  >Credit Card&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
                >
                <mat-radio-button value="Invoice"
                  >Invoice&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row" *ngIf="!isFreeTrial && orderTotalDue > 0">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <form class="standard-form">
                <ng-container *ngIf="orderPaymentMethod == 'Invoice'">
                  <mat-form-field>
                    <mat-label>PO Number</mat-label>
                    <input matInput name="poNumber" [(ngModel)]="poNumber" />
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="orderPaymentMethod == 'CreditCard'">
                  <mat-checkbox name="autoRenew" [(ngModel)]="autoRenew"
                    >&nbsp;&nbsp;&nbsp;&nbsp;Auto Renew My
                    Subscription</mat-checkbox
                  >
                  <mat-form-field>
                    <mat-label>Card Number</mat-label>
                    <input matInput name="ccNumber" [(ngModel)]="ccNumber" />
                  </mat-form-field>
                  <table>
                    <tr>
                      <td>
                        <mat-form-field>
                          <mat-label>Expiration Date Month</mat-label>
                          <mat-select
                            name="ccExpirationMonth"
                            style="width: 100%"
                            [(ngModel)]="ccExpirationMonth"
                          >
                            <mat-option
                              *ngFor="let month of ccAvailableMonths"
                              [value]="month"
                              >{{ month }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Expiration Date Year</mat-label>
                          <mat-select
                            name="ccExpirationYear"
                            style="width: 100%"
                            [(ngModel)]="ccExpirationYear"
                          >
                            <mat-option
                              *ngFor="let year of ccAvailableYears"
                              [value]="year"
                              >{{ year }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Card CVV</mat-label>
                          <input matInput name="ccCvv" [(ngModel)]="ccCvv" />
                        </mat-form-field>
                      </td>
                    </tr>
                  </table>
                </ng-container>
              </form>
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <button
                mat-raised-button
                class="piButton"
                (click)="processPayment()"
              >
                Submit
              </button>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="processingCreditCard && !donePurchasing">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Processing Purchase</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <i class="fas fa-spinner fa-pulse"></i
              >&nbsp;&nbsp;&nbsp;Processing your order, please wait...
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="donePurchasing && isExistingUser">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Purchase Complete</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <i class="fa fa-check-square"></i>&nbsp;&nbsp;&nbsp;Thank you for
              your purchase, you can view your subscription under subscription
              management.
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="donePurchasing && !isExistingUser">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Purchase Complete</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <i class="fa fa-check-square"></i>&nbsp;&nbsp;&nbsp;Thank you for
              your purchase, you can view your subscription under subscription
              management after you confirm your email address.
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <iframe style="display: none" [src]="payPalUrl"> </iframe>
</div>
